import React, { useState, useEffect } from "react";
import { AccordionBody, AccordionHeader, AccordionItem, Input, Label } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME } from "src/constant/common";
import { useTranslation } from "react-i18next";
import { PATTERN_NUMERIC_ARRAY_6DOF, MODE_FLAG } from "src/constant/common";

const InitialConditionPart = ({ errors, register, getValues, setValue }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  const modeFlagValue = getValues(`initial_condition.${FORM_NAME.INITIAL_CONDITION.INITIAL_MODEL}`) || 0;
  const [modeFlag, setModeFlag] = useState(modeFlagValue);

  useEffect(() => {
    setModeFlag(modeFlagValue);
  }, [modeFlagValue]);

  return (
    <AccordionItem>
      <AccordionHeader targetId="4" className="mt-0 fw-bold">
        {t("new.initial_condition.title")}
      </AccordionHeader>
      <AccordionBody accordionId="4">
        <div className="row">
          <div className="col-md-12 mb-3">
            <Label className="position-relative required-input">{t("new.initial_condition.mode_flag")}</Label>
            <div>
              <Input
                type="radio"
                id="modeFlag-asc"
                checked={modeFlag === MODE_FLAG.ASC}
                onChange={() => {
                  setValue(`initial_condition.${FORM_NAME.INITIAL_CONDITION.INITIAL_MODEL}`, MODE_FLAG.ASC);
                  setModeFlag(MODE_FLAG.ASC);
                }}
              />
              <Label for="modeFlag-asc" className="fw-normal mode-flag-label">
                {t("new.initial_condition.mode_flag_asc")}
              </Label>
              <Input
                type="radio"
                id="modeFlag-desc"
                className="ms-4"
                checked={modeFlag === MODE_FLAG.DESC}
                onChange={() => {
                  setValue(`initial_condition.${FORM_NAME.INITIAL_CONDITION.INITIAL_MODEL}`, MODE_FLAG.DESC);
                  setModeFlag(MODE_FLAG.DESC);
                }}
              />
              <Label for="modeFlag-desc" className="fw-normal mode-flag-label">
                {t("new.initial_condition.mode_flag_desc")}
              </Label>
            </div>
          </div>
          <div className="col-md-6">
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`}
              placeholder={t("new.field_placeholder", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`) })}
              classInput="width-by-percent-80"
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.POSITION]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`}
              placeholder={t("new.field_placeholder", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`) })}
              classInput="width-by-percent-80"
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.VELOCITY]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`) }),
              }}
              unit="x, y, z) (m/s"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`}
              placeholder={t("new.field_placeholder", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`) })}
              classInput="width-by-percent-80"
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`),
              })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`) }),
              }}
              unit="x, y, z) (deg"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`}
              placeholder={t("new.field_placeholder", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`),
              })}
              classInput="width-by-percent-80"
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY]?.message}
              requiredMessage={t("new.field_required", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`),
              })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`),
              })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`) }),
              }}
              unit="x, y, z) (deg/s"
            />
          </div>
          <div className="col-md-6">
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`}
              classInput="width-by-percent-80"
              placeholder={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}_placeholder`)}
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.ENGINE_STATE]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`) })}
              valueGreaterThanZero
              valueGreaterThanZeroMessage={t("new.field_min", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`),
              })}
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`}
              classInput="width-by-percent-80"
              placeholder={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}_placeholder`)}
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME]?.message}
              requiredMessage={t("new.field_required", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`),
              })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`),
              })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`),
              })}
              unit="s"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`)}
              name={`initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`}
              classInput="width-by-percent-80"
              placeholder={t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}_placeholder`)}
              errors={errors?.initial_condition?.[FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME]?.message}
              requiredMessage={t("new.field_required", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`),
              })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`),
              })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", {
                field: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`),
              })}
              unit="s"
            />
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default InitialConditionPart;
